import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import {Dialog, DialogActions, DialogTitle} from "@mui/material";

import CancelButtonStyled from "components/button/CancelButtonStyled";
import SaveButton from "components/button/SaveButton";

ConfirmationDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    value: PropTypes.string,
    tabName: PropTypes.string,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onExited: PropTypes.func,
};

/**
 * Confirmation step of the attribute quick-create flow, shown between the
 * "create" entry of the mapping select and the creation form.
 *
 * Kept as a standalone dialog so it can be dropped without touching the rest
 * of the flow if the confirmation step ends up being skipped.
 */
export default function ConfirmationDialog({isOpen, value, tabName, onConfirm, onCancel, onExited}) {
    return (
        <Dialog
            open={isOpen}
            onClose={onCancel}
            maxWidth={'xs'}
            scroll={'body'}
            // on cancel the mapping select reopens and must keep the focus:
            // MUI's default focus restore would blur it and close it right away
            disableRestoreFocus
            TransitionProps={{onExited}}
        >
            <DialogTitle>
                <FormattedMessage
                    id={'attributeQuickCreate.confirm.title'}
                    values={{value: value ?? '', tab: tabName ?? ''}}
                />
            </DialogTitle>
            <DialogActions>
                <CancelButtonStyled onClick={onCancel}>
                    <FormattedMessage id={'list.button.cancel'} />
                </CancelButtonStyled>
                <SaveButton onClick={onConfirm}>
                    <FormattedMessage id={'list.button.add'} />
                </SaveButton>
            </DialogActions>
        </Dialog>
    );
}
